export default "__VITE_ASSET__DYOAjsDX__"